export class BeneficiaryInfo {
    constructor(
        public ClientType: string,
        public FirstName: string,
        public MiddleName: string,
        public LastName: string,
        public Name: string,
        public RelationshipToPrimary: string,
        public MailingAddress: string,
        public City: string,
        public State: string,
        public ZipCode: string,
        public LanguagePreference: string,
        public PercentageSplit: number,
        public Prefix?: string,
        public Suffix?: string,
    ) {}
  }
